import React, { useState, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import experience1 from '../../../images/ExperiencePage/MrSea_Experience1.png';
import experience2 from '../../../images/ExperiencePage/MrSea_Experience2.png';
import experience3 from '../../../images/ExperiencePage/MrSea_Experience3.png';
import experience4 from '../../../images/ExperiencePage/MrSea_Experience4.png';
import experience5 from '../../../images/ExperiencePage/MrSea_Experience5.png';
import experience6 from '../../../images/ExperiencePage/MrSea_Experience6.png';

const SLIDE_COUNT = 6;
const AUTOPLAY_INTERVAL_MS = 3000;

const slides = [
  { src: experience1, title: 'Yacht & Toys' },
  { src: experience2, title: 'Cheers on board' },
  { src: experience3, title: 'Stunning Views from Miami' },
  { src: experience4, title: 'Bride team on board' },
  { src: experience5, title: 'The Real Miami Boating Experience' },
  { src: experience6, title: 'Miami at night' },
];

const LandingHeroCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);

  const goNext = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % SLIDE_COUNT);
  }, []);

  const goPrev = useCallback(() => {
    setCurrentIndex((prev) => (prev - 1 + SLIDE_COUNT) % SLIDE_COUNT);
  }, []);

  useEffect(() => {
    const id = setInterval(goNext, AUTOPLAY_INTERVAL_MS);
    return () => clearInterval(id);
  }, [goNext]);

  return (
    <div
      className={`landing-hero-carousel landing-skeleton-image-wrap${imageLoaded ? ' landing-skeleton-image-wrap--loaded' : ''}`}
    >
      <div className="landing-skeleton" aria-hidden="true" />
      <div className="landing-hero-carousel__viewport">
        <div
          className="landing-hero-carousel__track"
          style={{ transform: `translateX(-${currentIndex * (100 / SLIDE_COUNT)}%)` }}
        >
          {slides.map((slide, idx) => (
            <div key={idx} className="landing-hero-carousel__slide">
              <img
                src={slide.src}
                alt="Luxury Miami boat experience - VIP yacht day on the water"
                className="landing-hero__support-image"
                width="1200"
                height="768"
                fetchPriority={idx === 0 ? 'high' : 'low'}
                loading={idx === 0 ? 'eager' : 'lazy'}
                onLoad={idx === 0 ? () => setImageLoaded(true) : undefined}
              />
              <span className="landing-hero-carousel__slide-title">{slide.title}</span>
            </div>
          ))}
        </div>
      </div>
      <button
        type="button"
        className="landing-hero-carousel__arrow landing-hero-carousel__arrow--left"
        onClick={goPrev}
        aria-label="Previous slide"
      >
        <FontAwesomeIcon icon={faChevronLeft} className="landing-hero-carousel__arrow-icon" />
      </button>
      <button
        type="button"
        className="landing-hero-carousel__arrow landing-hero-carousel__arrow--right"
        onClick={goNext}
        aria-label="Next slide"
      >
        <FontAwesomeIcon icon={faChevronRight} className="landing-hero-carousel__arrow-icon" />
      </button>
    </div>
  );
};

export default LandingHeroCarousel;
